import React from 'react';
import '../../CustomAssets/Css/Components/Modal.css';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { NavLink } from 'react-router-dom';

const Modal = ({ isOpen, onClose, title, data }) => {
  if (!isOpen || !data) return null;

  const half = Math.ceil(data.listItems.length / 2);
  const firstHalf = data.listItems.slice(0, half);
  const secondHalf = data.listItems.slice(half);

  return (
    <div className="planModal-overlay">
      <div className="planModal-content">
        <button className="planModal-close" onClick={onClose}>&times;</button>

        <h2 className="planModal-title">{title} plan at only ₹{data.price}</h2>
        <p className="planModal-body">{data.description}</p>

        <div className="planModal-lists">
          <ul>
            {firstHalf.map((item, index) => (
              <li key={`first-${item}-${index}`}>
                <div className='divCheck_price'><IoMdCheckmarkCircleOutline className='check_price' /></div>
                <div className='plandetatils_text'><span>{item}</span></div>
              </li>
            ))}
          </ul>
          <ul>
            {secondHalf.map((item, index) => (
              <li key={`first-${item}-${index}`}>
                <div className='divCheck_price'><IoMdCheckmarkCircleOutline className='check_price' /></div>
                <div className='plandetatils_text'><span>{item}</span></div>
              </li>
            ))}
          </ul>
        </div>

        <div className="btn-cta planModalapply">

          <NavLink
            to="/contactUs"
            className="btn_theme mt_40 btn_clr plan_applyBtn">
            Apply
          </NavLink>

        </div>

        {/* <button className="planModal-apply-btn" onClick={onClose}>Close</button> */}
      </div>
    </div>
  );
};

export default Modal;
